module.exports = __webpack_public_path__ + "img/chofu_learn_on.d1718f19.svg";